module.exports = __webpack_public_path__ + "static/img/85-2.7256e44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/85-2.jpg
// module id = yepD
// module chunks = 0